import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

import { MessageBannerComponent } from './message-banner.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatButtonModule, MatCardModule],
  declarations: [MessageBannerComponent],
  exports: [MessageBannerComponent],
})
export class MessageBannerModule {}
